module.exports = "import Draggable from 'react-draggable';\nimport { List } from 'react-virtualized';\n\nfunction rowRenderer ({ index, isScrolling, key, style }) {\n  return (\n    <div\n      key={index}\n      style={style}\n    >\n      {...}\n\n      <Draggable\n        axis='y'\n        onStop={\n          (event, data) => resizeRow({ deltaY: data.y, index })\n        }\n      />\n    </div>\n  );\n}\n\nfunction renderList (listProps) {\n  return (\n    <List\n      {...listProps}\n      ref={(ref) => this._list = ref}\n      rowRenderer={rowRenderer}\n    />\n  );\n}\n"


/*****************
 ** WEBPACK FOOTER
 ** ./~/raw-loader!./examples/resizable-cells-key-points.js
 ** module id = 378
 ** module chunks = 0
 **/